(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["celane-size-guide"] && !Shopify.designMode) return;
  try {
    class CelaneSizeGuide extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('.celane-sg__open');
      if (!this.dialog || !this.opener) return;
      this.opener.addEventListener('click', () => this.open());
      this.dialog.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.removeAttribute('data-celane-dialog-open');
        this.opener.setAttribute('aria-expanded', 'false');
      });
    }

    open() {
      if (typeof this.dialog.showModal !== 'function') return;
      this.dialog.showModal();
      document.documentElement.setAttribute('data-celane-dialog-open', '');
      this.opener.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.dialog.close();
    }
  }

  if (!customElements.get('celane-size-guide')) customElements.define('celane-size-guide', CelaneSizeGuide);
  } catch(e) { console.error(e); }
})();

})();
